import React from 'react';
import './EmptyState.css';

function EmptyState({
  icon = null,
  title,
  description = null,
  action = null,
  className = '',
}) {
  return (
    <div className={`ui-empty-state ${className}`} role="status">
      {icon && <div className="ui-empty-state__icon" aria-hidden="true">{icon}</div>}
      {title && <h3 className="ui-empty-state__title">{title}</h3>}
      {description && <p className="ui-empty-state__description">{description}</p>}
      {action && <div className="ui-empty-state__action">{action}</div>}
    </div>
  );
}

export default EmptyState;
